import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useCallback } from 'react';

var useInputFieldEventsHandler = function useInputFieldEventsHandler(disabled) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focusCaptured = _useState2[0],
    setFocusCaptured = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hoverCaptured = _useState4[0],
    setHoverCaptured = _useState4[1];
  var onFocusCapture = useCallback(function () {
    return !disabled && setFocusCaptured(true);
  }, [disabled]);
  var onBlurCapture = useCallback(function () {
    return setFocusCaptured(false);
  }, []);
  var onMouseEnter = useCallback(function () {
    return !disabled && setHoverCaptured(true);
  }, [disabled]);
  var onMouseLeave = useCallback(function () {
    return setHoverCaptured(false);
  }, []);
  return {
    focusCaptured: focusCaptured,
    hoverCaptured: hoverCaptured,
    onFocusCapture: onFocusCapture,
    onBlurCapture: onBlurCapture,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
};

export { useInputFieldEventsHandler };
